import React, { useEffect, useState } from "react";
import CustomPagination from "../components/Shared/CustomPagination";
import { FaEye, FaPrint } from "react-icons/fa";
import { IoIosSend } from "react-icons/io";
import CustomTable from "../components/Shared/CustomTable";
import Filters from "./Filters";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import supergitHIS from "../api/supergitHIS";
import toast from "react-hot-toast";
import TableLoading from "../components/Shared/TableLoading";
import SharedButton from "../components/Shared/SharedButton";
import { getDateRange } from "./ThirdParty";
import moment from "moment";
import { ProgressSpinner } from "primereact/progressspinner";
import { FaFileInvoice, FaPencil } from "react-icons/fa6";
import { useSelector } from "react-redux";
import InvoiceDetails from "./InvoiceDetails";
import StoreRevokeUpdate from "./StoreRevokeUpdate";
import { MdCancel } from "react-icons/md";
import validSupergitHIS from "../api/validSupergitHIS";
import ConfirmationDialog from "../components/Shared/ConfirmationDialog";
import { statusBody } from "../Pages/insuranceClaimInvoice/InsuranceClaimTable";

const RevokeStoreInvocies = ({ activeTab }) => {
  const key = "store-revoke-invoices";
  const { user } = useSelector((state) => state?.auth);
  const [openFilter, setOPenFilters] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [zatcaLoading, setIsZatcaLoading] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [zatcaIndex, setZatcaIndex] = useState(-1);
  const [pollLoading, setIsPollLoading] = useState(false);
  const [date, setDate] = useState({
    from: getDateRange("lastDay").from,
    to: getDateRange("lastDay").to,
  });
  const [confirmationDialogVisible, setConfirmationDialogVisible] =
    useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [payload, setPayload] = useState(
    localStorage.getItem(key)
      ? JSON.parse(localStorage.getItem(key))
      : {
        orderDateFrom: null,
        orderDateTo: null,
        ClientOrderID: null,
        zatcaStatus: null,
        storeId: user?.thirdparty_branch_id,
        page: 1,
        pageSize: 10,
      },
  );
  const [data, setData] = useState([]);
  const [isListLoading, setIsListLoading] = useState(false);
  const [vsData, setVsData] = useState(null);
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const templateBody = (rowData, col) => (
    <div className="flex gap-3 items-center justify-center">
      <FaFileInvoice
        className=" cursor-pointer"
        size={16}
        title=" Invoice Details"
        onClick={() => {
          getInvoiceDetails(rowData?.ClientRevokeID).then(() => {
            setVisible(true);
          });
        }}
      />
      <FaPencil
        className=" cursor-pointer"
        size={16}
        title="Invoice Details"
        onClick={() => {
          getInvoiceDetails(rowData?.ClientRevokeID).then(() => {
            setEditVisible(true);
          });
        }}
      />
      {rowData?.ZatcaStatus || rowData?.zatcaStatus !== "REPORTED" ? null : (
        <FaPrint
          className=" cursor-pointer"
          size={16}
          title="Details"
          onClick={() => {
            navigate(
              `/zatca/thirdparty/invoice-details/${rowData.clientRevokeId}`,
              {
                state: {
                  status: rowData?.ZatcaStatus || rowData?.zatcaStatus,
                  module: activeTab,
                  invoiceData: rowData,
                  url: "invoices/clientRevokes/",
                },
              },
            );
          }}
        />
      )}

      {rowData?.ZatcaStatus || rowData?.zatcaStatus === "REPORTED" ? null : zatcaLoading &&
        col?.rowIndex == zatcaIndex ? (
        <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin" />
      ) : (
        <IoIosSend
          className=" cursor-pointer"
          size={16}
          title="Send To Zatca"
          onClick={() => {
            SendToZatca(rowData.ClientOrderID);
          }}
        />
      )}
      {rowData?.InvoiceStatus?.toLowerCase() === "cancelled" ||
        rowData?.ZatcaStatus || rowData?.zatcaStatus ? null : (
        <MdCancel
          size={28}
          data-tooltip-id="cancel"
          className="!p-1 !text-red-500 cursor-pointer"
          onClick={() => {
            setConfirmationDialogVisible(true);
            setSelectedEntry(rowData);
          }}
        />
      )}
    </div>
  );
  const statusTemplate = (rowData) => {
    return (
      <div>
        {rowData?.ZatcaStatus || rowData?.zatcaStatus === "REPORTED" ? (
          <div className="bg-green-500 !w-[100px] p-1 text-center text-white rounded-md">
            {rowData?.ZatcaStatus || rowData?.zatcaStatus}
          </div>
        ) : (
          <div className="bg-red-500 p-1 !w-[100px] text-center text-white rounded-md">
            UNREPORTED
          </div>
        )}
      </div>
    );
  };

  const columnsData = [
    { body: templateBody, header: t("Actions") },
    {
      body: (R) => statusBody(R, t),
      header: t("Status"),
    },
    { body: statusTemplate, header: t("Zatca Status") },

    {
      field: "ClientOrderID",
      header: t("Order Id"),
      style: { width: "8rem" },
    },
    { field: "ClientName", header: t("Client Name") },
    {
      field: "OrderDate",
      header: t("Order Date"),
      body: (rowData) =>
        moment(rowData?.RevokeDate).format("DD-MM-YYYY HH:mm a"),
    },
    { field: "StoreName", header: t("Store Name") },
    { field: "LocalSerial", header: t("Local Serial") },
    { field: "SalesPersonName", header: t("Sales Person Name") },
    {
      field: "TotalPrice",
      header: t("Total Price"),
      body: (rowData) => `${rowData.RevokeAmount} SAR`,
    },
    { field: "Address", header: t("Address") },
    { field: "FirstPhone", header: t("First Phone") },
    {
      body: (data) => (
        <div>
          {data?.RevokeAmount > 1000 && data?.ClientVAt ? "B2B" : "B2C"}
        </div>
      ),
      header: t("Type"),
    },
  ];

  const onPageChange = (page, rowsPerPage) => {
    setPayload({ ...payload, page, pageSize: rowsPerPage });
  };

  const SendToZatca = async (id) => {
    try {
      setIsZatcaLoading(true);
      const res = await validSupergitHIS.get(
        `zatca2/sendRevokeToZatcaClient/${id}/8ab7f7d1-8fa2-47a8-966d-97fbec298e31`,
      );
      toast.success(res.data?.message);
      await fetchListData(payload);
      setIsZatcaLoading(false);
    } catch (err) {
      setIsZatcaLoading(false);
      console.error(err);
    }
  };

  const fetchPollData = async () => {
    setIsPollLoading(true);
    try {
      const response = await validSupergitHIS.post(
        `hussam/transfer/client-revokes/sync?from_date=${date.to}`,
      );
      toast.success(response?.data?.message);
      fetchListData(payload);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsPollLoading(false);
    }
  };

  const fetchListData = async (payload) => {
    setIsListLoading(true);
    try {
      const response = await validSupergitHIS.post(
        "invoices/clientRevokes/filter",
        payload,
      );
      setData(response.data || []);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsListLoading(false);
    }
  };
  const getInvoiceDetails = async (payload) => {
    setIsListLoading(true);
    try {
      const response = await validSupergitHIS.get(
        `invoices/clientRevokes/details/${payload}`,
      );
      setVsData(response.data || []);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsListLoading(false);
    }
  };
  useEffect(() => {
    fetchListData(payload);
  }, [payload.page, payload?.pageSize]);

  const handleDeleteAccount = async () => {
    try {
      setIsLoading(true);
      const res = await validSupergitHIS.post(
        `invoices/clientRevokes/cancel/byInvoice/${selectedEntry?.InvoiceId}`,
      );
      toast.success(res.data?.message);
      await fetchListData(payload);
      setConfirmationDialogVisible(false);
      setSelectedEntry(null);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.error(err);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-end mb-2 gap-2">
        <SharedButton
          icon="pi pi-sync"
          label={
            <div className="flex items-center gap-2">
              {t("Polling")}
              {pollLoading && (
                <ProgressSpinner
                  className="w-5 h-5 spinner-white"
                  style={{ stroke: "white" }}
                />
              )}
            </div>
          }
          disabled={pollLoading}
          className="bg-primary primary-btn"
          onClick={fetchPollData}
        />
        {/* <SharedButton
        icon="pi pi-filter"
          label={t("apply_filters")}
          severity="warning"
          outlined
          className="!p-1.5 font-extralight !border-primary !text-primary"
          onClick={() => setOPenFilters(true)}
        /> */}
      </div>
      <Filters
        storageKey={key}
        visible={openFilter}
        setVisible={() => setOPenFilters(false)}
        filters={payload}
        setFilters={setPayload}
        fetchData={fetchListData}
        loading={isLoading}
      />
      <CustomTable
        data={data?.data}
        isLoading={isListLoading || zatcaLoading || pollLoading}
        loadingIcon={<TableLoading />}
        columns={columnsData}
        rows={data.total}
        setZatcaIndex={setZatcaIndex}
      />
      <CustomPagination
        currentPage={data?.page || payload?.page}
        rowsPerPage={data?.page_size || data?.pageSize || payload?.pageSize || 10}
        totalRecords={
          data?.total_pages ||
          data?.totalPages ||
          Math.ceil(
            (data?.total_records ||
              data?.totalRecords ||
              data?.summary?.totalRecords ||
              data?.total_record ||
              0) / (data?.page_size || data?.pageSize || payload?.pageSize || 10),
          )
        }
        totalRecord={
          data?.total_records ||
          data?.totalRecords ||
          data?.summary?.totalRecords ||
          data?.total_record ||
          0
        }
        onPageChange={onPageChange}
      />

      <InvoiceDetails
        visible={visible}
        onHide={() => {
          setVisible(false);
          setVsData(null);
        }}
        data={vsData}
        type="revokeStore"
      />
      <StoreRevokeUpdate
        fetchAgain={fetchListData}
        setVisible={setEditVisible}
        revokeData={vsData}
        setRevokeData={setVsData}
        visible={editVisible}
      />
      <ConfirmationDialog
        loading={isLoading}
        title={t("delete_confirmation_popup_text")}
        isDialogVisible={confirmationDialogVisible}
        setIsDialogVisible={setConfirmationDialogVisible}
        confirmHandler={handleDeleteAccount}
        onHide={() => setSelectedEntry(null)}
      />
    </div>
  );
};

export default RevokeStoreInvocies;
